export default "__VITE_ASSET__O0in7q2S__"